import React from 'react';
import { Modal } from '@opendoor/bricks/complex';
import { Text, Flex, Box, Button } from '@opendoor/bricks/core';
import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

interface IConfirmationModalProps {
  overrideContent?: React.ReactNode;
  showConfirmationModal: boolean;
  setShowConfirmationModal: (show: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 */
export const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
  showConfirmationModal,
  setShowConfirmationModal,
  onCancel,
  onConfirm,
  overrideContent,
}) => {
  return (
    <Modal
      analyticsName="cake-confirmation-modal"
      maxWidth={520}
      isOpen={showConfirmationModal}
      showClose
      onRequestClose={() => setShowConfirmationModal(false)}
      headerProps={{ title: 'Confirm', titleProps: { as: 'h2' } }}
    >
      {overrideContent ? (
        overrideContent
      ) : (
        <Text textAlign="center" mb={8}>
          This is {getRailsEnv()} environment, are you sure that you want to proceed?
        </Text>
      )}
      <Flex justifyContent="space-bewteen" alignItems="center">
        <Box width="50%" mr={5}>
          <Button
            aria-label="Cancel selected date and time"
            variant="secondary"
            analyticsName="cake-confirmation-modal-cancel-date-button"
            // @ts-expect-error Bricks intentionally doesn't allow customization of border radii on buttons. Product teams should resolve this violation
            borderRadius="full"
            onClick={() => {
              onCancel();
              setShowConfirmationModal(false);
            }}
          >
            Cancel
          </Button>
        </Box>
        <Box width="50%">
          <Button
            analyticsName="cake-confirmation-modal-confirm-date-button"
            aria-label="Confirm selected date and time"
            onClick={() => {
              onConfirm();
              setShowConfirmationModal(false);
            }}
            variant="primary"
            // @ts-expect-error Bricks intentionally doesn't allow customization of border radii on buttons. Product teams should resolve this violation
            borderRadius="full"
          >
            Confirm
          </Button>
        </Box>
      </Flex>
    </Modal>
  );
};
